import { render, staticRenderFns } from "./UserPermission.vue?vue&type=template&id=7ae2334d&scoped=true&"
import script from "./UserPermission.vue?vue&type=script&lang=js&"
export * from "./UserPermission.vue?vue&type=script&lang=js&"
import style0 from "./UserPermission.vue?vue&type=style&index=0&id=7ae2334d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae2334d",
  null
  
)

export default component.exports